export default {
  name: "CalendarPending",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d:
      "M28 5h-4V3c0-.55-.45-1-1-1s-1 .45-1 1v2H10V3c0-.55-.45-1-1-1s-1 .45-1 1v2H4c-1.16 0-2 .84-2 2v21c0 1.16.84 2 2 2h24c1.16 0 2-.84 2-2V7c0-1.16-.84-2-2-2zm0 23H4V7h4v1c0 .55.45 1 1 1s1-.45 1-1V7h12v1c0 .55.45 1 1 1s1-.45 1-1V7h4v21zm-6.07-5.63c-.21.52-.8.76-1.3.56l-5-2A1 1 0 0 1 15 20v-7c0-.55.45-1 1-1s1 .45 1 1v6.32l4.37 1.75c.51.21.76.79.56 1.3z",
  },
}
